import { ModelBase } from "./model-base";

export class NutritionHelper extends ModelBase {

  kj: number = 8400;
  kcal: number = 2000;
  protein: number = 50;
  carbohydrate: number = 260;
  carbohydrateOfWhichSugars: number = 90;
  fat: number = 70;
  fatOfWhichSaturates: number = 20;
  fibre: number = 30;
  sodium: number = 6000;
  salt: number = 6;

  constructor(s?: any) {
    super(s);
    
  }

  static colorCodingData = {
    carbohydrateOfWhichSugars: {
      maxLow: 5,
      maxMedium: 22.5,
      maxPerPortion: 27
    },
    fat: {
      maxLow: 3,
      maxMedium: 17.5,
      maxPerPortion: 21
    },
    fatOfWhichSaturates: {
      maxLow: 1.5,
      maxMedium: 5,
      maxPerPortion: 6
    },
    salt: {
      maxLow: 0.3,
      maxMedium: 1.5,
      maxPerPortion: 1.8
    }
  };
}
